var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'step-item',
    _vm.stepIndex === _vm.currentStepIndex ? 'active-class' : '',
    _vm.isDisabled ? 'disabled-class' : ''
  ],on:{"click":_vm.selectStep}},[_c('el-badge',{class:[_vm.isChanged ? 'changed' : ''],attrs:{"type":_vm.badgeStatus,"value":_vm.stepIndex + 1}}),_vm._v("\n  "+_vm._s(_vm.step.title)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8f2772","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/page/PageStep.vue
// module id = null
// module chunks = 